import React from "react";
import { useStore } from "../../store";

interface BoomIndicatorProps {
  className?: string;
  angle: number;
  maxAngle?: number;
  minAngle?: number;
}

export const BoomIndicator: React.FC<BoomIndicatorProps> = ({
  className = "",
  angle,
  maxAngle,
  minAngle,
}) => {
  const { craneParameters } = useStore();

  const angleOffset = 90;

  // Use store values if not provided as props
  const effectiveMaxAngle =
    angleOffset - (maxAngle ?? craneParameters.boomMaxAngle);
  const effectiveMinAngle =
    angleOffset - (minAngle ?? craneParameters.boomMinAngle);

  const isMoving = craneParameters.boomSpeed !== 0;

  return (
    <svg
      width="86"
      height="83.3008"
      viewBox="0 0 86 83.3008"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* <path
        // fills the possible range arc
        d="M37.5 27L44.5 14L47 15.5L53.5 20L60 25L64 29L53.5 39.5L48.5 35L43 31L37.5 27Z"
        fill="#D7DADC"
      /> */}
      <path
        d="M85.4118 83.1152L7.39453 83.1152"
        stroke="white"
        strokeWidth="0.54"
      />
      <path
        d="M5.69531 3.60381L5.69531 81.6211"
        stroke="white"
        strokeWidth="0.54"
      />

      <g clipPath="url(#arc)">
        <g transform="translate(5.5 0)">
          <path
            d={`M${Math.sin((90 * Math.PI) / 180) * 83} ${
              83 - Math.cos((90 * Math.PI) / 180) * 83
            } L0 83.3008 L${Math.sin(((90 - angle) * Math.PI) / 180) * 83} ${
              83 - Math.cos(((90 - angle) * Math.PI) / 180) * 83
            }  L83 0 Z`}
            fill={isMoving ? "#00E676" : "#D7DADC"}
          />
          <line
            x1="0"
            y1="0"
            x2="0"
            y2="83.3008"
            stroke="#CD151D"
            strokeWidth="2.025"
            style={{
              transformOrigin: "bottom left",
              transform: `rotate(${effectiveMinAngle}deg)`,
            }}
          />
          <line
            x1="0"
            y1="0"
            x2="0"
            y2="83.3008"
            stroke="#CD151D"
            strokeWidth="2.025"
            style={{
              transformOrigin: "bottom left",
              transform: `rotate(${effectiveMaxAngle}deg)`,
            }}
          />
        </g>
      </g>
      <g transform="translate(5.5 0)">
        <line
          x1="0"
          y1="0"
          x2="0"
          y2="83.3008"
          stroke="white"
          strokeWidth="2.08"
          style={{
            transformOrigin: "bottom left",
            transform: `rotate(${90 - angle}deg)`,
          }}
        />
        {/* <path d="M53 40L64.8016 29.0254" stroke="#CD151D" strokeWidth="2.025" /> */}
      </g>
      <circle cx="5.5" cy="83.3008" r="2.5" fill="white" />
      <path
        d="M85.4116 83.3179C85.4116 39.2918 49.7214 3.60156 5.69531 3.60156"
        stroke="white"
        strokeWidth="1.08"
      />
      <path d="M70 83C70 47.6538 41.3462 19 6 19" stroke="white" />

      <defs>
        <clipPath id="arc">
          {/* <path
            d="M85.4116 83.3179C85.4116 39.2918 49.7214 3.60156 5.69531 3.60156 L 6 19 C 41.3462 19 70 47.6538 70 83Z"
            fill="white"
          /> */}
          <path
            d="M85.4116 83.3179C85.4116 39.2918 49.7214 3.60156 5.69531 3.60156L6 19C41.3462 19 70 47.6538 70 83L85.4116 83.1152Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
